import { escapeHtml, formatTimeAgo, getAvatarUrl } from '../../utils/helpers';
import BaseView from '../../common/base-view';

export default class PostView extends BaseView {
  constructor() {
    super();
    this.postId = null;
    this.postMap = null;
    this.layerItems = [];
  }

  async render() {
    return `
      <div id="page-post" class="page-content active">
        <section class="post-wrapper" aria-labelledby="single-post-title">
          <h2 id="single-post-title" class="sr-only">Detail Postingan</h2>
          <div class="single-post-container" id="single-post-container">
            <div class="loading-post">
              <div class="hg-animate" aria-hidden="true"></div>
              <p>Memuat postingan...</p>
            </div>
          </div>
        </section>
      </div>
    `;
  }

  afterRender() {}

  setPostId(id) {
    this.postId = id;
  }

  showLoading(container) {
    super.showLoading(container, 'Memuat postingan...');
  }

  showAuthRequired(container, onLoginClick) {
    super.showAuthRequired(
      container,
      'Silakan masuk atau daftar untuk melihat postingan',
      'post-login-btn',
      onLoginClick
    );
  }

  showError(container, message) {
    super.showEmptyState(container, message);
  }

  renderPost(story, isBookmarked) {
    const timeAgo = formatTimeAgo(story.createdAt);
    const locationParagraphId = `location-text-${story.id}`;
    const postHtml = `
      <article class="postingan" data-story-id="${story.id}">
        <div class="post-user">
          <div class="user-sender">
            <div class="poster-photo">
              <img src="${getAvatarUrl(story.name)}" alt="Foto profil ${story.name}" width="48" height="48" loading="lazy">
            </div>
            <div class="sender-post">
              <h3>${story.name}</h3>
              ${story.lat && story.lon ? `
                <button type="button" class="location-sender" aria-label="Lihat lokasi" data-text_tip="Lihat lokasi" data-hover_tip="right" data-dev_tip="desktop">
                  <span class="material-symbols-rounded" aria-hidden="true">location_on</span>
                  <p id="${locationParagraphId}">Memuat lokasi...</p>
                </button>
              ` : ''}
            </div>
          </div>
          <div class="time-post">
            <p data-timestamp="${story.createdAt}">${timeAgo}</p>
          </div>
        </div>
        <div class="isi-postingan">
          <div class="post-text">${escapeHtml(story.description)}</div>
          ${story.photoUrl ? `<div class="post-image"><img src="${story.photoUrl}" alt="Story image" loading="lazy"></div>` : ''}
        </div>
        ${story.lat && story.lon ? `<div class="location-view"><div class="map-container" id="single-post-map"></div></div>` : ''}
        <div class="action-post">
          <button class="bookmark-this ${isBookmarked ? 'bookmarked' : ''}" data-story-id="${story.id}" data-text_tip="${isBookmarked ? 'Hapus dari bookmark' : 'Tambah ke bookmark'}" data-hover_tip="top" data-dev_tip="desktop">
            <span class="material-symbols-rounded" aria-hidden="true">bookmark</span>
            <span>${isBookmarked ? 'Tersimpan' : 'Simpan'}</span>
          </button>
          <button class="share-this" data-story-id="${story.id}" data-text_tip="Bagikan cerita" data-hover_tip="top" data-dev_tip="desktop">
            <span class="material-symbols-rounded" aria-hidden="true">share</span>
            <span>Bagikan</span>
          </button>
        </div>
      </article>
    `;
    this.setContent('#single-post-container', postHtml);
  }

  updateLocationName(storyId, locationName) {
    const locationEl = document.querySelector(`#location-text-${storyId}`);
    if (locationEl) locationEl.textContent = locationName;
  }

  updateBookmarkStatus(storyId, isBookmarked) {
    const btn = document.querySelector(`.bookmark-this[data-story-id="${storyId}"]`);
    if (!btn) return;
    if (isBookmarked) {
      btn.classList.add('bookmarked');
      btn.querySelector('span:last-child').textContent = 'Tersimpan';
      btn.setAttribute('data-text_tip', 'Hapus dari bookmark');
    } else {
      btn.classList.remove('bookmarked');
      btn.querySelector('span:last-child').textContent = 'Simpan';
      btn.setAttribute('data-text_tip', 'Tambah ke bookmark');
    }
  }

  initializeMap(config) {
    try {
      this.postMap = new maplibregl.Map(config);
      this.postMap.addControl(new maplibregl.NavigationControl(), 'top-right');
      return this.postMap;
    } catch (e) {
      throw new Error('Gagal memuat peta: ' + e.message);
    }
  }

  addMapLayerControl(onLayerChange, selectedLayer = 'streets') {
    if (!this.postMap) return;
    const view = this;
    this.layerItems = [];

    class LayerControl {
      onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group';

        const button = document.createElement('button');
        button.className = 'maplibregl-ctrl-icon';
        button.type = 'button';
        button.innerHTML = '<span class="material-symbols-rounded">layers</span>';
        button.title = 'Ubah layer peta';

        const dropdown = document.createElement('div');
        dropdown.className = 'layer-dropdown';
        dropdown.style.cssText = 'position: absolute; top: 100%; left: 0; background: var(--bg-container); border: 1px solid var(--border-color); border-radius: 4px; display: none; min-width: 120px; box-shadow: 0 2px 4px rgba(0,0,0,0.2);';

        const layers = [
          { name: 'Streets', value: 'streets' },
          { name: 'Satellite', value: 'satellite' },
          { name: 'Terrain', value: 'terrain' },
        ];

        layers.forEach((layer) => {
          const item = document.createElement('div');
          item.textContent = layer.name;
          item.className = 'layer-list';
          item.dataset.layer = layer.value;
          item.style.cssText = 'padding: 8px 12px; cursor: pointer; color: var(--text-primary);';
          if (layer.value === selectedLayer) item.classList.add('active');
          item.addEventListener('click', () => {
            onLayerChange(layer.value);
            dropdown.style.display = 'none';
          });
          dropdown.appendChild(item);
          view.layerItems.push(item);
        });

        button.addEventListener('click', (e) => {
          e.stopPropagation();
          dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
        });

        document.addEventListener('click', () => {
          dropdown.style.display = 'none';
        });

        this._container.appendChild(button);
        this._container.appendChild(dropdown);
        return this._container;
      }

      onRemove() {
        if (this._container && this._container.parentNode) {
          this._container.parentNode.removeChild(this._container);
        }
        this._map = undefined;
      }
    }

    this.layerControl = new LayerControl();
    this.postMap.addControl(this.layerControl, 'top-left');
  }

  setMapStyle(styleUrl, onLoaded) {
    if (this.postMap) {
      if (onLoaded) {
        this.postMap.once('styledata', () => onLoaded());
      }
      this.postMap.setStyle(styleUrl);
    }
  }

  updateLayerSelection(layerType) {
    if (this.layerItems) {
      this.layerItems.forEach((el) => {
        el.classList.toggle('active', el.dataset.layer === layerType);
      });
    }
  }

  addMarker(lon, lat, popupHtml) {
    if (!this.postMap) return;
    const popup = new maplibregl.Popup({ offset: 25 }).setHTML(popupHtml);
    new maplibregl.Marker({ color: '#B84C28' })
      .setLngLat([lon, lat])
      .setPopup(popup)
      .addTo(this.postMap);
  }

  setupPostInteractionEventListeners(onBookmark, onShare, onImageClick) {
    this.globalClickHandler = (e) => {
      const bookmarkBtn = e.target.closest('.bookmark-this');
      if (bookmarkBtn) {
        e.stopPropagation();
        const storyId = bookmarkBtn.dataset.storyId;
        onBookmark(storyId);
        return;
      }

      const shareBtn = e.target.closest('.share-this');
      if (shareBtn) {
        e.stopPropagation();
        const storyId = shareBtn.dataset.storyId;
        onShare(storyId);
        return;
      }

      const postImage = e.target.closest('.post-image img');
      if (postImage) {
        e.stopPropagation();
        onImageClick(postImage.src);
        return;
      }
    };

    document.addEventListener('click', this.globalClickHandler);
  }

  setMapCenter(lon, lat, zoom = 15) {
    if (this.postMap) {
      this.postMap.setCenter([lon, lat]);
      this.postMap.setZoom(zoom);
    }
  }

  isDarkMode() {
    return document.body.classList.contains('dark');
  }

  cleanup() {
    if (this.globalClickHandler) {
      document.removeEventListener('click', this.globalClickHandler);
      this.globalClickHandler = null;
    }
    if (this.postMap) {
      this.postMap.remove();
      this.postMap = null;
    }
  }
}
